import { AnalyticsTrackingEvent, ProductRewardSearchResult } from '@brandclub/common-ui';
import { useCartUpdates } from '../../api/cache/cartQueryOptions';
import { useTrackActions } from '../../hooks/useTracking';
import { CartRefusal } from '../../utils/cartValidation';
import BagDrawer from '../BagButton/BagDrawer';
import { ADD_NOT_FINISHED, AddToBagOutcome } from './useAddToBagIntent';

/**
 * THE Add to bag of this app, for the in-page button and for a host page alike. The bag drawer opens at the press,
 * and the line lands in it when the cart saves it. A refused save rolls the bag back and puts its sentence at the top
 * of the drawer. A cart limit and the server's own sentence keep their words. Any other failure gives one fixed
 * sentence.
 */
export function useAddToBagWrite(): (target: ProductRewardSearchResult, quantity: number) => Promise<AddToBagOutcome> {
  const { mutateAsync: updateCart } = useCartUpdates();
  const [trackCheckoutBarAction] = useTrackActions();

  return async (target, quantity) => {
    trackCheckoutBarAction(AnalyticsTrackingEvent.WEB_APP_ORGANIC_ADD_TO_CART, {
      stacklineSku: target.stacklineSku,
      retailerId: target.retailerId,
      retailerSku: target.retailerSku,
      retailPrice: target.retailPrice,
      quantity,
      source: 'brandclub_dtc_checkout_bar',
    });
    BagDrawer.show();
    try {
      await updateCart({ action: 'add', items: [{ ...target, quantity }], retailerId: target.retailerId });
      return { status: 'added' };
    } catch (error) {
      if (!(error instanceof CartRefusal)) console.error('Add to bag failed', error);
      const message = error instanceof CartRefusal ? error.message : ADD_NOT_FINISHED;
      BagDrawer.refuse(message);
      return { status: 'refused', message };
    }
  };
}
